import { get } from 'lodash';

export const getQueueStatus = state =>
  get(state, 'PointOfSaleState.queue.queueStatus');

export const getQueue = state => get(state, 'PointOfSaleState.queue.queue', []);

export const getQueueStartedPreviously = state =>
  get(state, 'PointOfSaleState.queue.queueStartedPreviously', false);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/state/selectors.js